import {dashboardApi} from 'sources/api';
import AnnotatedScorecardResult from 'records/AnnotatedScorecardResult';
import {WidgetConfig} from '../@types/dash';
import startCase from 'lodash/startCase';
import mapKeys from 'lodash/mapKeys';
import {UserId} from 'records/User';

const DATE_FORMAT = 'YYYY-MM-DD';

export class WebDataRocksSource {
  static fetchData(params: WidgetConfig, managerId: UserId): Promise<AnnotatedScorecardResult[]> {
    const query = managerId ? `?managerId=${managerId}` : '';
    return dashboardApi
      .postJson(`/raw_scores${query}`, {
        ...params,
        startDate: params.startDate.format(DATE_FORMAT),
        endDate: params.endDate.format(DATE_FORMAT),
      })
      .then(results => results.map(obj => mapKeys(obj, (_, key) => startCase(key))));
  }

  static getLicenseKey(): Promise<string | undefined> {
    return dashboardApi
      .get('/flexmonster')
      .then(r => r.data)
      .catch(e => {
        if (e.response.status === 404) {
          return undefined;
        }
        throw e;
      });
  }
}
